import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "./footer.css";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    const chatBox = document.querySelector(".chat-box");
    if (chatBox) chatBox.scrollTop = 0;

    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const handleLinkClick = (e, to) => {
    e.preventDefault();

    if (location.pathname === to) {
      scrollToTop();
    } else {
      navigate(to);
      setTimeout(scrollToTop, 50);
    }
  };

  return (
    <footer>
      <div className="footer-section copyright-section">
        <p>© 2025 Mindly. All rights reserved.</p>
      </div>

      <div className="footer-section legal-section">
        <a href="/terms" onClick={(e) => handleLinkClick(e, "/terms")}>
          Terms & Conditions
        </a>
        <span className="divider">|</span>
        <a href="/privacy" onClick={(e) => handleLinkClick(e, "/privacy")}>
          Privacy Policy
        </a>
      </div>

      <div className="footer-section contact-section">
        <a href="mailto:mindlyservices@gmail.com" target="_blank" rel="noopener noreferrer">
          <MdEmail size={20} />
        </a>
        <a href="https://www.linkedin.com/company/mindlyweb/" target="_blank" rel="noopener noreferrer">
          <FaLinkedin size={20} />
        </a>
        <a href="https://www.instagram.com/mindlywebdotcom/" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={20} />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
